export const WAYS_ST_JAMES_SCHEMA = [
  {
    field: 'name',
    label: 'Nombre',
  },
  {
    field: 'province',
    label: 'Provincias',
  },
  {
    field: 'lengthStr',
    label: 'Longitud',
    sortable: false,
    classObj: ['query__header--align-right'],
  },
];
